<template>
  <v-app id="inspire" class="bodyPadding">
    <mo-header></mo-header>
    <v-content>		
		<quote-head></quote-head>		
		<quote-list></quote-list>
    </v-content>
  </v-app>
</template>

<script>

	import QuoteHead from './Header.vue';	
	import QuoteList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
			QuoteHead,			
			QuoteList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>